import { render, staticRenderFns } from "./pad_welcome.vue?vue&type=template&id=309345cb&scoped=true"
import script from "./pad_welcome.vue?vue&type=script&lang=js"
export * from "./pad_welcome.vue?vue&type=script&lang=js"
import style0 from "./pad_welcome.vue?vue&type=style&index=0&id=309345cb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309345cb",
  null
  
)

export default component.exports